module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    staticClass: "modal-fade",
    attrs: {
      "name": "modal-fade"
    }
  }, [_c('div', {
    staticClass: "modal-backdrop"
  }, [_c('form', {
    attrs: {
      "action": "#",
      "method": "post"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.copyReengagement.apply(null, arguments)
      }
    }
  }, [_c('div', {
    ref: "",
    staticClass: "copy-modal",
    attrs: {
      "role": "dialog",
      "aria-labelledby": "modalTitle",
      "aria-describedby": "modalDescription"
    }
  }, [_c('header', {
    staticClass: "modal-header"
  }, [_vm._t("header", function() {
    return [_vm._v("\n            Copy Reengagement\n            "), _c('div', {
      staticClass: "closeButton"
    })]
  })], 2), _vm._v(" "), _c('section', {
    staticClass: "copy-modal-body"
  }, [_c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    staticStyle: {
      "font-weight": "500"
    },
    attrs: {
      "for": "campaign"
    }
  }, [_vm._v("Current Reengagement Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8 control-label",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('strong', [_vm._v(" " + _vm._s(_vm.currentName) + " ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-8 control-label",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('strong', {
    staticClass: "text-red"
  }, [_vm._v(" Reengagement can be copied to this instance only. ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label required",
    staticStyle: {
      "font-weight": "500"
    },
    attrs: {
      "for": "campaign"
    }
  }, [_vm._v("New Reengagement Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8 control-label",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "name",
      "placeholder": "New Reengagement Name"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.submitted && !_vm.$v.name.required) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please provide a reengagement name.")]) : _vm._e(), _vm._v(" "), (_vm.submitted && _vm.name === _vm.currentName) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please provide a new reengagement name.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    staticStyle: {
      "font-weight": "500"
    },
    attrs: {
      "for": "campaign"
    }
  }, [_vm._v("Select Deployment Date")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8 control-label",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deploymentDate),
      expression: "deploymentDate"
    }],
    staticClass: "form-control",
    class: {
      'form-group--error': _vm.submitted && !_vm.$v.deploymentDate.required
    },
    attrs: {
      "min": _vm.getDate(),
      "type": "date"
    },
    domProps: {
      "value": (_vm.deploymentDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.deploymentDate = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.submitted && !_vm.$v.deploymentDate.required) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please choose a deployment date.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    staticStyle: {
      "font-weight": "500"
    },
    attrs: {
      "for": "campaign"
    }
  }, [_vm._v("Select Deployment Time")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8 control-label",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deploymentTime),
      expression: "deploymentTime"
    }],
    staticClass: "form-control",
    class: {
      'form-group--error': _vm.submitted && !_vm.$v.deploymentTime.required,
    },
    attrs: {
      "type": "time"
    },
    domProps: {
      "value": (_vm.deploymentTime)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.deploymentTime = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.submitted && !_vm.$v.deploymentTime.required) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please choose a deployment date.")]) : _vm._e()])])])]), _vm._v(" "), _c('footer', {
    staticClass: "copy-modal-footer"
  }, [_vm._t("footer", function() {
    return [_c('button', {
      staticClass: "btn btn-primary",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.close()
        }
      }
    }, [_vm._v("\n              Cancel\n            ")]), _vm._v(" "), _c('input', {
      staticClass: "btn btn-primary",
      attrs: {
        "type": "submit",
        "value": "Copy"
      }
    })]
  })], 2)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-565cc873","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reengagement-manager/copyModal.vue
// module id = Pn8L
// module chunks = 1